import queryString from "query-string";

import { defaultDealsQueries } from "constants/deal";
import { DealsQueries, UrlQueryParams } from "store/types";

export default (): DealsQueries => {
  const filteredEmail = location.search.replace(/(email.+)\+/g, "%2B");
  const queryParams: UrlQueryParams = queryString.parseUrl(filteredEmail).query;

  const dealsQueriesFromUrl = queryParams.deals && JSON.parse(queryParams.deals);
  return {
    ...defaultDealsQueries,
    ...(dealsQueriesFromUrl || {})
  };
};
